import { queryOptions, useQuery } from '@tanstack/react-query';
import { TruckRecordingMipFilterDTO, TruckRecordingMipFilterOptionsDTO, TruckRecordingMipService } from '../generated';

export interface TruckRecordingMipFilterOptionsProps {
  jobsiteId?: string;
  filter?: TruckRecordingMipFilterDTO;
}

export const truckRecordingMipFilterOptionsQueryKeys = {
  base: () => ['truckRecordingMipFilterOptions'] as const,
  options: ({ jobsiteId, filter }: TruckRecordingMipFilterOptionsProps) =>
    [...truckRecordingMipFilterOptionsQueryKeys.base(), jobsiteId, filter] as const,
};

export function truckRecordingMipFilterOptions({ jobsiteId, filter }: TruckRecordingMipFilterOptionsProps) {
  return queryOptions({
    queryKey: truckRecordingMipFilterOptionsQueryKeys.options({ jobsiteId, filter }),
    queryFn: async (): Promise<TruckRecordingMipFilterOptionsDTO> => {
      if (!jobsiteId) {
        throw new Error('jobsiteId is required');
      }

      const response = await TruckRecordingMipService.truckRecordingMipControllerGetFilterOptions({
        path: { jobsiteId },
        query: { filter: [filter || {}] },
      });

      if (response.data !== undefined) {
        return response.data;
      }

      throw (response as any).error || new Error(response.response?.statusText || 'Unknown error');
    },
    enabled: !!jobsiteId,
  });
}

export function useTruckRecordingMipFilterOptions(props: TruckRecordingMipFilterOptionsProps) {
  return useQuery(truckRecordingMipFilterOptions(props));
}
